export enum AnnuityTypeFile {
    CGADB = "C",
    CONFRADESP = "F",
    OTHER = "O"
}